"use client";

import { c as _c } from "react/compiler-runtime";
import { useId, useRef, useState } from "react";
import { MnemonicGridUi } from "./mnemonic-grid-ui";
import { normalizeRecoveryWords, RECOVERY_WORD_COUNTS, validateRecoveryPhrase } from "./recovery-phrase-model";
export interface RecoveryPhraseInputProps {
  onValidated: (words: string) => void | Promise<void>;
  onCancel: () => void;
  pending?: boolean;
  error?: string;
}
export function RecoveryPhraseInput(t0) {
  const $ = _c(60);
  const {
    onValidated,
    onCancel,
    pending: t1,
    error
  } = t0;
  const pending = t1 === undefined ? false : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = new Array(12).fill("");
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const [words, setWords] = useState(t2);
  const [invalid, setInvalid] = useState(false);
  const form = useRef(null);
  const id = useId();
  let t3;
  if ($[1] !== onValidated || $[2] !== pending || $[3] !== words) {
    t3 = async event => {
      event.preventDefault();
      if (pending) {
        return;
      }
      let phrase;
      try {
        phrase = validateRecoveryPhrase(words.join(" "));
      } catch {
        setInvalid(true);
        form.current?.querySelector("input")?.focus();
        return;
      }
      setInvalid(false);
      await onValidated(phrase);
    };
    $[1] = onValidated;
    $[2] = pending;
    $[3] = words;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== id) {
    t4 = <label className="text-sm" htmlFor={id}>Recovery phrase</label>;
    $[5] = id;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== words) {
    t5 = event_0 => {
      const count = Number(event_0.target.value);
      setWords(Array.from({
        length: count
      }, (_, index) => words[index] ?? ""));
      setInvalid(false);
    };
    $[7] = words;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const t6 = words.length;
  let t7;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = RECOVERY_WORD_COUNTS.map(_temp);
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== id || $[11] !== pending || $[12] !== t5 || $[13] !== words.length) {
    t8 = <select aria-label="Recovery phrase word count" className="rounded-md border bg-background px-2 py-1 text-sm" disabled={pending} id={id} onChange={t5} value={t6}>{t7}</select>;
    $[10] = id;
    $[11] = pending;
    $[12] = t5;
    $[13] = words.length;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t4 || $[16] !== t8) {
    t9 = <div className="flex items-center justify-between gap-3">{t4}{t8}</div>;
    $[15] = t4;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  const t10 = `${id}-hint`;
  let t11;
  if ($[18] !== t10) {
    t11 = <p className="text-muted-foreground text-sm" id={t10}>Type or paste your recovery phrase.</p>;
    $[18] = t10;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  const t12 = `${id}-hint${invalid ? ` ${id}-error` : ""}`;
  let t13;
  if ($[20] !== pending) {
    t13 = event_1 => {
      if (pending) {
        return;
      }
      const pasted = normalizeRecoveryWords(event_1.clipboardData.getData("text")).split(" ");
      if (pasted.length <= 1) {
        return;
      }
      event_1.preventDefault();
      if (!RECOVERY_WORD_COUNTS.some(count_1 => count_1 === pasted.length)) {
        setInvalid(true);
        return;
      }
      setWords(pasted);
      setInvalid(false);
    };
    $[20] = pending;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  let t14;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <legend className="sr-only">Recovery phrase words</legend>;
    $[22] = t14;
  } else {
    t14 = $[22];
  }
  let t15;
  if ($[23] !== words) {
    t15 = new Set(words.map(_temp2));
    $[23] = words;
    $[24] = t15;
  } else {
    t15 = $[24];
  }
  let t16;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = (index_1, value) => {
      setWords(previous => previous.map((word, position) => position === index_1 ? value.trim().toLowerCase() : word));
      setInvalid(false);
    };
    $[25] = t16;
  } else {
    t16 = $[25];
  }
  let t17;
  if ($[26] !== t15 || $[27] !== words) {
    t17 = <MnemonicGridUi columns={3} editablePositions={t15} onWordChange={t16} words={words} />;
    $[26] = t15;
    $[27] = words;
    $[28] = t17;
  } else {
    t17 = $[28];
  }
  let t18;
  if ($[29] !== invalid || $[30] !== pending || $[31] !== t12 || $[32] !== t13 || $[33] !== t17) {
    t18 = <fieldset aria-describedby={t12} aria-invalid={invalid} disabled={pending} onPaste={t13}>{t14}{t17}</fieldset>;
    $[29] = invalid;
    $[30] = pending;
    $[31] = t12;
    $[32] = t13;
    $[33] = t17;
    $[34] = t18;
  } else {
    t18 = $[34];
  }
  let t19;
  if ($[35] !== id || $[36] !== invalid) {
    t19 = invalid && <p className="text-destructive text-sm" id={`${id}-error`} role="alert">Check the word count, spelling, and checksum.</p>;
    $[35] = id;
    $[36] = invalid;
    $[37] = t19;
  } else {
    t19 = $[37];
  }
  let t20;
  if ($[38] !== error) {
    t20 = error && <p className="text-destructive text-sm" role="alert">{error}</p>;
    $[38] = error;
    $[39] = t20;
  } else {
    t20 = $[39];
  }
  let t21;
  if ($[40] !== pending || $[41] !== words) {
    t21 = pending || words.some(_temp3);
    $[40] = pending;
    $[41] = words;
    $[42] = t21;
  } else {
    t21 = $[42];
  }
  const t22 = pending ? "Checking\u2026" : "Find my account";
  let t23;
  if ($[43] !== pending || $[44] !== t21 || $[45] !== t22) {
    t23 = <button aria-busy={pending} className="min-h-11 rounded-md bg-primary px-4 text-primary-foreground" disabled={t21} type="submit">{t22}</button>;
    $[43] = pending;
    $[44] = t21;
    $[45] = t22;
    $[46] = t23;
  } else {
    t23 = $[46];
  }
  let t24;
  if ($[47] !== onCancel) {
    t24 = <button className="min-h-11 rounded-md border px-4" onClick={() => {
      setWords(new Array(12).fill(""));
      setInvalid(false);
      onCancel();
    }} type="button">Cancel</button>;
    $[47] = onCancel;
    $[48] = t24;
  } else {
    t24 = $[48];
  }
  let t25;
  if ($[49] !== t23 || $[50] !== t24) {
    t25 = <div className="flex flex-wrap gap-3">{t23}{t24}</div>;
    $[49] = t23;
    $[50] = t24;
    $[51] = t25;
  } else {
    t25 = $[51];
  }
  let t26;
  if ($[52] !== t11 || $[53] !== t18 || $[54] !== t19 || $[55] !== t20 || $[56] !== t25 || $[57] !== t3 || $[58] !== t9) {
    t26 = <form className="space-y-4" onSubmit={t3} ref={form}>{t9}{t11}{t18}{t19}{t20}{t25}</form>;
    $[52] = t11;
    $[53] = t18;
    $[54] = t19;
    $[55] = t20;
    $[56] = t25;
    $[57] = t3;
    $[58] = t9;
    $[59] = t26;
  } else {
    t26 = $[59];
  }
  return t26;
}
function _temp3(word_0) {
  return !word_0.trim();
}
function _temp2(__0, index_0) {
  return index_0;
}
function _temp(count_0) {
  return <option key={count_0} value={count_0}>{count_0} words</option>;
}